export default {
  install (Vue) {
    const sendMessage = (op, value = null) => {
      window.parent.postMessage({
        id: Vue.fpConfig.IFRAME_ID,
        op,
        value
      }, '*')
    }
    Vue.sendMessage = Vue.prototype.$sendMessage = sendMessage
  }
}
